import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MaintenanceProblemService } from '../shared/services/maintenance-problem.service';
import { resourcesImages } from 'src/app/shared/const/images-resources';
import { URL_ASSETS } from 'src/app/shared/const';
import { routesV3 } from '../shared/const/routes-config';
import { SplashStyles } from '../shared/interfaces/splash/splash-styles';
import { SplashFallBack } from '../shared/interfaces/splash/splash-fallback';


@Component({
  selector: 'app-maintenance-problem-ui',
  templateUrl: './maintenance-problem-ui.component.html',
  styleUrls: ['./maintenance-problem-ui.component.scss']
})
export class MaintenanceProblemUiComponent {

  problemStart!: Date | null;
  resources!: Array<any>;
  retriying = false;
  timezone!: string;

  // Default message
  errorMessage = 'The itopia system is currently experiencing some technical issues.The team are aware and are working diligently to have the system back up and running as soon as possible.';

  // Configurable styles
  dynamicStyles: SplashStyles = {
    textFontsize: '1rem',
    textColor: 'white',
    iconName: 'warning',
    iconColor: '#f44336'
  };
  constructor(private router: Router, private maintenanceProblemService: MaintenanceProblemService) {
    this.resources = [
      URL_ASSETS + resourcesImages['itopia-logo-dark'],
    ];
    this.updateData();
  }

  goToDashboard(): void {
    const route = routesV3.cloudapps.children.checkrole.route;
    void this.router.navigate([route]);
  }


  retry(): void {
    try {
      this.retriying = true;

      // REDIRECT TO DASHBOARD IF SYSTEM IS NOT MAINTENANCE
      void this.maintenanceProblemService.getMaintenanceProblemConfig().then((resolve) => {
        this.retriying = false;
        if (resolve) {
          this.goToDashboard();
        } else {
          this.updateData();
        }
      });

    } catch (error) {
      this.retriying = false;
    }
  }

  updateData(): void {
    const status = this.maintenanceProblemService.systemStatus;

    // Read from storage if service has no data
    const storedConfig = sessionStorage.getItem('systemStatusConfig');
    const fallback: Partial<SplashFallBack> = storedConfig
      ? (JSON.parse(storedConfig) as SplashFallBack)
      : {};

    // Get the start date of the problem
    const eventStart =
      status?.eventStartedAt ||
      fallback?.eventProblemStart;

    this.problemStart = eventStart ? new Date(eventStart) : null;

    // User's local timezone
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Set error message
    this.errorMessage =
      status?.description ||
      fallback?.description ||
      this.errorMessage;

    // Process dynamic styles from either service or storage
    const styleSource =
      status?.descriptionStyle ||
      fallback?.descriptionStyle;

    if (styleSource) {
      const parsed = this.parseStyle(styleSource) as SplashStyles;

      // Apply only the values that exist; fallback to existing defaults
      this.dynamicStyles = {
        ...this.dynamicStyles, // keeps defaults
        ...parsed               // overrides with backend values
      } as SplashStyles;
    }
  }

  // Converts the string from the backend into a usable object
  private parseStyle(styleString: string): Partial<SplashStyles> {
    if (!styleString) return {};

    // Allowed keys based on SplashStyles interface
    const validKeys: (keyof SplashStyles)[] = [
      'textFontsize',
      'textColor',
      'iconName',
      'iconColor'
    ];

    const parsed: Partial<SplashStyles> = {};

    // Split by comma and process pairs
    styleString.split(',').forEach(part => {
      const [rawKey, rawValue] = part.split(':');
      if (!rawKey || !rawValue) return;

      const key = rawKey.trim() as keyof SplashStyles;

      // Ignore keys not present in the interface
      if (!validKeys.includes(key)) return;

      const value = rawValue.trim().replace(/^'|'$/g, ''); // remove quotes
      parsed[key] = value;
    });

    return parsed;
  }

}
